import { render, staticRenderFns } from "./OrgEdit.vue?vue&type=template&id=2c74974d"
import script from "./OrgEdit.vue?vue&type=script&lang=js"
export * from "./OrgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports